import React, { useEffect, useReducer } from 'react';
import FileManagerWrapper from 'components/filemanager/filemanager.style';
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RoyTooltip from "components/common/RoyTooltip";
import MediaDialog from 'components/filemanager/MediaDialog';
import FolderDialog from 'components/filemanager/FolderDialog';
import { initialState, reducer } from 'components/filemanager/reducer';
import ListView from 'components/filemanager/listview/ListView'

const FileManager = props => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const { 
        moveToFolderDialog, 
        moveToFolderMedia, 
        medias, 
        folders, 
        isViewFolder,
        currentFolder, 
        openMediaDialog, 
        currentMedia,
    } = state

    useEffect(() => {
        fetch('/service/archieves?folder=root')
            .then(res=> res.json())
            .then(val => {
                dispatch({
                    data: {
                        folders: val
                    }
                })
            })
    }, [])

    const openFileORFolder = (data, type) => {
        var path = '';
        if (data.type === "folder") {

            data.id = data.id < 10 ? ("0"+parseInt(data.id)) : data.id;
            path = data.folder_id ? data.folder_id : "";

            fetch(`/service/archieves?folder=${data.folder}&file=${data.id}&rootfolder=${data.root_folder}&subfolder=${path}&type=${type}`)
                .then(res => res.json())
                .then(val => {
                    if(val.length) {
                        if(val[0].type === 'folder'){
                            dispatch({
                                data: {
                                    isViewFolder: val[0].depth,
                                    currentFolder: data,
                                    folders: val
                                }
                            })
                        } else {
                            dispatch({
                                data: {
                                    isViewFolder: val[0].depth,
                                    currentFolder: data,
                                    medias: val
                                }
                            })
                        }
                    }
                })
                
            
        } else {
            
            data.id = data.id < 10 ? ("0"+parseInt(data.id)) : data.id;
            path = data.folder_id ? data.folder_id : "";
            
            fetch(`/service/archieves?folder=${data.folder_id}&file=${data.id}&rootfolder=${data.root_folder}&subfolder=${data.subfolder}&type=${type}`)
            .then(res => res.json())
            .then(val => {
                dispatch({
                    data: {
                        openMediaDialog: true,
                        currentMedia: val
                    }
                })
            })
        }
    }

    const setRootPath = () => {

        if(isViewFolder === 1) {
            fetch('/service/archieves?folder=root')
            .then(res=> res.json())
            .then(val => {
                if(val.length) {
                    dispatch({
                        data: {
                            isViewFolder: val[0].depth,
                            folders: val,
                            currentFolder: {}
                        }
                    })
                }
            })
        } else if (isViewFolder === 2){
            fetch(`/service/archieves?folder=year&file=${currentFolder.root_folder}`)
            .then(res=> res.json())
            .then(val => {
                if(val.length) {
                    dispatch({
                        data: {
                            isViewFolder: val[0].depth,
                            currentFolder: {
                                "id": val[0].folder_id,
                                "folder": "year",
                                "depth": 0,
                                "name": val[0].folder_id,
                                "type": "folder", 

                            },
                            folders: val
                        }
                    })
                }
            })
        } else if (isViewFolder === "3"){
            fetch(`/service/archieves?folder=month&file=${currentFolder.folder_id}&rootfolder=${currentFolder.root_folder}`)
            .then(res=> res.json())
            .then(val => {
                if(val.length) {
                    dispatch({
                        data: {
                            isViewFolder: val[0].depth,
                            currentFolder: {
                                "id": val[0].folder_id,
                                "folder": "month",
                                "depth": 1,
                                "name": val[0].folder_id,
                                "folder_id": val[0].root_folder,
                                "root_folder": val[0].root_folder 

                            },
                            folders: val
                        }
                    })
                }
            })
        }
    }

    const deleteFolder = (data) => {
        dispatch({
            type: 'deleteFolder',
            id: data.id
        })
    }
    
    const deleteFile = (data) => {
        dispatch({
            type: 'deleteFile',
            id: data.id
        })
    }

    const openFolderDialog = (data) => {
        dispatch({
            data: {
                moveToFolderDialog: true,
                moveToFolderMedia: data.id
            }
        })
    }



    const moveFiletoFolderHandler = (folder_id) => {
        if(moveToFolderMedia && folder_id) {
            dispatch({
                type: "moveMediaToFolder",
                mediaId: moveToFolderMedia,
                folderId: folder_id
            })
        }
        resetFolderModal()
    }

    const resetFolderModal = () => {
        dispatch({
            type: 'resetFolderModal'
        })
    }

    const resetMediaModal = () => {
        dispatch({
            type: 'resetMediaModal'
        })
    }

    return (
        <FileManagerWrapper {...props}>
            <div>
                <PageTitle
                    title="sidebar.filemanager"
                    className="plr-15"
                    breadCrumb={[
                        {
                            name: "sidebar.app"
                        },
                        {
                            name: "sidebar.filemanager"
                        }
                    ]}
                />
            </div>
            <div className="file-manager-toolbar flex-x">
                <div className="flex-1">
                    <span className="fs-16 demi-bold-text">Storage &gt; root</span> 

                    {
                        (currentFolder.folder === "year") &&
                        <span> 
                            <span className="fs-16 demi-bold-text"> &gt; { currentFolder.name }</span>
                        </span>
                    }
                    {
                        (currentFolder.folder === "month") &&
                        <span> 
                            <span className="fs-16 demi-bold-text"> &gt; { currentFolder.root_folder }</span>
                            <span className="fs-16 demi-bold-text"> &gt; { currentFolder.name }</span>
                        </span>
                    }
                    {
                        (currentFolder.folder === "class") &&
                        <span> 
                            <span className="fs-16 demi-bold-text"> &gt; { currentFolder.root_folder }</span>
                            <span className="fs-16 demi-bold-text"> &gt; { currentFolder.folder_id }</span>
                            <span className="fs-16 demi-bold-text"> &gt; { currentFolder.name }</span>
                        </span>
                    }

                    
                </div>

                {
                    currentFolder.id && 
                    <div className="ml-10">
                        <RoyTooltip id={`back`} title={"Geri"} placement="bottom">
                            <div id={`back`} className="cursor-pointer" onClick={setRootPath}>
                                <i className="fas fa-step-backward fs-20"></i>
                            </div>
                        </RoyTooltip>
                    </div>
                }
            </div>
            <div className="pt-10">
                {
                    <ListView
                        medias={medias}
                        folders={folders}
                        isViewFolder={isViewFolder}
                        currentFolder={currentFolder}
                        openFileORFolder={openFileORFolder}
                        deleteFolder={deleteFolder}
                        deleteFile={deleteFile}
                        moveToFolder={openFolderDialog}
                    />
                }
            </div>
            <MediaDialog
                className="media-modal"
                modal={openMediaDialog}
                setmodal={resetMediaModal}
                currentMedia={currentMedia}
            />
            <FolderDialog
                className="media-modal"
                modal={moveToFolderDialog}
                setmodal={resetFolderModal}
                folders={folders}
                moveFiletoFolderHandler={moveFiletoFolderHandler}
            />

        </FileManagerWrapper>
    );
};

const mapStateToProps = state => {
    return {
        ...state.themeChanger,
    };
};

export default connect(
    mapStateToProps
)(FileManager);